module.exports = __webpack_public_path__ + "static/media/org_IMG_2838.e44d8e85.jpg";